var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v23.992H0z",
    "data-name": "Rectangle 16224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.088 4.774V.002h4.774v1.636H2.725v3.136Zm20.186 0V1.638h-3.137V.002h4.774v4.772ZM1.088 24.002V19.23h1.637v3.136h3.137v1.636Zm17.049 0v-1.636h3.137V19.23h1.637v4.772ZM5.998 19.091h12V4.911h-12Zm0 1.636a1.678 1.678 0 0 1-1.637-1.636V4.911a1.678 1.678 0 0 1 1.637-1.636h12a1.678 1.678 0 0 1 1.637 1.636v14.18a1.678 1.678 0 0 1-1.637 1.636Zm3-11.18h6V7.911h-6Zm0 3.272h6v-1.637h-6Zm0 3.272h6v-1.636h-6Zm-3 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfCopy);
export default __webpack_public_path__ + "static/media/pdf-copy.d7a87bfef2c8a14845f158252cb089d6.svg";
export { ForwardRef as ReactComponent };